import http from "../http-common";

class RegulatoryExchangeService {
  getAllRegulatoryExchange() {
    return http.get("/regulatory-exchange");
  }
}

export default new RegulatoryExchangeService();
